/* eslint-disable no-undef */
import {
  setDataStatisticRequest,
  setDataStatisticSuccess,
  setDataStatisticFailure,
} from '.';
import { AdminService } from '../../services/requests';

const StatisticHelper = {
  getAllStatistic: () => async (dispatch) => {
    dispatch(setDataStatisticRequest());
    try {
      const response = await AdminService.getModeratedInfo();
      if (response) {
        dispatch(setDataStatisticSuccess(response));
      }
    } catch {
      dispatch(setDataStatisticFailure());
    }
  },
};

export default StatisticHelper;
